"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _usePrevious = _interopRequireDefault(require("react-utils/hooks/usePrevious"));

var _enviro = _interopRequireDefault(require("enviro"));

var _memoizeStringOnly = _interopRequireDefault(require("./vendor/memoizeStringOnly"));

var _RhumbContext = _interopRequireDefault(require("./internal/RhumbContext"));

var ActionTypes = _interopRequireWildcard(require("./internal/ActionTypes"));

var Constants = _interopRequireWildcard(require("./internal/Constants"));

var ResultStatus = _interopRequireWildcard(require("./internal/ResultStatus"));

var _matchRoute = _interopRequireDefault(require("./internal/matchRoute"));

var _consoleReporter = _interopRequireDefault(require("./internal/consoleReporter"));

var _reaganCompatReporter = require("./internal/reaganCompatReporter");

var ReporterActionTypes = _interopRequireWildcard(require("./internal/ReporterActionTypes"));

var _Scheduler = require("./internal/Scheduler");

var _performanceNow = _interopRequireDefault(require("./vendor/performanceNow"));

var _legacyHubspotBenderContext = require("legacy-hubspot-bender-context");

var useInitial = function useInitial(initialValue) {
  var ref = (0, _react.useRef)(null);

  if (!ref.current) {
    ref.current = {
      value: initialValue()
    };
  }

  return ref.current.value;
};

var formatVersion = function formatVersion(version) {
  return version.startsWith('static-') ? version.substr(7) : 'dev';
};

var buildRouteSpecs = function buildRouteSpecs(partialRouteSpecs, defaultTimeout) {
  if (process.env.NODE_ENV !== 'production') {
    (0, _invariant.default)(partialRouteSpecs, 'routeSpecs cannot be null');
  } // TODO devLogger warn deprecation


  var normalizeSuccess = function normalizeSuccess() {
    var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return Array.isArray(success) ? {
      default: success
    } : success;
  };

  return Object.keys(partialRouteSpecs).reduce(function (acc, route) {
    var routeSpec = partialRouteSpecs[route];
    var success = routeSpec.success,
        _routeSpec$error = routeSpec.error,
        error = _routeSpec$error === void 0 ? [] : _routeSpec$error,
        _routeSpec$timeout = routeSpec.timeout,
        timeout = _routeSpec$timeout === void 0 ? defaultTimeout : _routeSpec$timeout;
    acc[route] = {
      route: route,
      success: normalizeSuccess(success),
      error: error,
      timeout: timeout
    };
    return acc;
  }, {});
};

var buildGetRouteSpec = function buildGetRouteSpec(routeSpecs) {
  var routeKeys = Object.keys(routeSpecs);
  var routeMatcher = (0, _matchRoute.default)(routeKeys);
  return (0, _memoizeStringOnly.default)(function (pathname) {
    var route = routeKeys.find(function (key) {
      return routeMatcher(key, pathname);
    });
    return routeSpecs[route];
  });
};

var buildCheckStatus = function buildCheckStatus(getRouteSpec) {
  var checkStatusImpl = function checkStatusImpl(_ref) {
    var pathname = _ref.pathname,
        checks = _ref.checks,
        expiredTimestamp = _ref.expiredTimestamp;
    var routeSpec = getRouteSpec(pathname); // TODO DOCUMENT success wins all ties

    if (expiredTimestamp) {
      return {
        type: ResultStatus.TIMEOUT
      };
    } else {
      var isMounted = function isMounted(marker) {
        return checks[marker] && checks[marker].mounted;
      };

      var scenarios = Object.keys(routeSpec.success).filter(function (scenario) {
        return routeSpec.success[scenario].length && routeSpec.success[scenario].every(isMounted);
      });

      if (scenarios.length) {
        // TODO warn if multiple
        return {
          type: ResultStatus.SUCCESS,
          scenario: scenarios[0]
        };
      } else if (routeSpec.error.some(isMounted)) {
        return {
          type: ResultStatus.FAILURE
        };
      }
    }

    return {
      type: ResultStatus.PENDING
    };
  };

  return (0, _memoizeOne.default)(checkStatusImpl);
};

var buildReporter = function buildReporter(getRouteSpec, report) {
  var forActionType = function forActionType(type, entry, extra) {
    var pathname = entry.pathname;
    var routeSpec = getRouteSpec(pathname);
    var payload = {
      entry: entry,
      routeSpec: routeSpec
    };

    if (extra) {
      Object.assign(payload, {
        extra: extra
      });
    }

    return {
      type: type,
      payload: payload
    };
  };

  return function () {
    return report(forActionType.apply(void 0, arguments));
  };
};

var reducer = function reducer(prevState, action) {
  var prevEntry = prevState.entry,
      _prevState$entry = prevState.entry,
      prevPathname = _prevState$entry.pathname,
      prevId = _prevState$entry.id,
      prevChecks = _prevState$entry.checks,
      prevEntries = prevState.entries;

  switch (action.type) {
    case ActionTypes.HISTORY_CHANGED:
      {
        var _action$payload = action.payload,
            pathname = _action$payload.pathname,
            timestamp = _action$payload.timestamp;
        return pathname !== prevPathname ? (0, _extends4.default)({}, prevState, {
          entry: {
            id: prevId + 1,
            pathname: pathname,
            referrer: prevPathname,
            timestamp: timestamp,
            checks: {}
          },
          entries: [].concat((0, _toConsumableArray2.default)(prevEntries), [prevEntry])
        }) : prevState;
      }

    case ActionTypes.MARKER_MOUNTED:
      {
        var _action$payload2 = action.payload,
            _action$payload2$mark = _action$payload2.marker,
            marker = _action$payload2$mark.name,
            id = _action$payload2$mark.id,
            _timestamp = _action$payload2.timestamp;

        if (process.env.NODE_ENV !== 'production') {
          if (prevChecks[marker] && prevChecks[marker].mounted) {
            console.error('[react-rhumb] marker already rendered: "%s". Rendering duplicate markers is deprecated and route failure in the next version', marker);
          }
        }

        return prevId === id ? (0, _extends4.default)({}, prevState, {
          entry: (0, _extends4.default)({}, prevEntry, {
            dirty: true,
            checks: (0, _extends4.default)({}, prevChecks, (0, _defineProperty2.default)({}, marker, (0, _extends4.default)({}, prevChecks[marker], {
              mounted: true,
              timestamp: _timestamp
            })))
          })
        }) : prevState;
      }

    case ActionTypes.MARKER_UNMOUNTED:
      {
        var _action$payload$marke = action.payload.marker,
            _marker = _action$payload$marke.name,
            _id = _action$payload$marke.id;
        return prevId === _id && prevChecks[_marker] && prevChecks[_marker].mounted ? (0, _extends4.default)({}, prevState, {
          entry: (0, _extends4.default)({}, prevEntry, {
            checks: (0, _extends4.default)({}, prevChecks, (0, _defineProperty2.default)({}, _marker, (0, _extends4.default)({}, prevChecks[_marker], {
              mounted: false,
              timestamp: undefined
            })))
          })
        }) : prevState;
      }

    case ActionTypes.TIMEDOUT:
      {
        var _timestamp2 = action.payload.timestamp;
        return (0, _extends4.default)({}, prevState, {
          entry: (0, _extends4.default)({}, prevEntry, {
            expiredTimestamp: _timestamp2
          })
        });
      }

    default:
      throw new Error("unexpected action " + action.type);
  }
};

var usePreventPropChange = process.env.NODE_ENV !== 'production' ? function (props) {
  var propsRef = (0, _react.useRef)(props);
  (0, _react.useEffect)(function () {
    (0, _invariant.default)(propsRef.current.config === props.config, '`config` should not change');
    (0, _invariant.default)(propsRef.current.history === props.history, '`history` should not change');
    propsRef.current = props;
  }, [props]);
} : function () {};

var useHistoryEffect = function useHistoryEffect(history, callback) {
  var queue = (0, _react.useRef)([]);
  var flush = (0, _react.useRef)(null);
  var savedCallback = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    savedCallback.current = callback;
  });

  if (!flush.current) {
    var unlisten = history.listen(function (_ref2) {
      var pathname = _ref2.pathname;
      var timestamp = (0, _performanceNow.default)();
      queue.current.push({
        pathname: pathname,
        timestamp: timestamp
      });
    });

    flush.current = function () {
      unlisten();
      queue.current.forEach(savedCallback.current);
      queue.current = [];

      flush.current = function () {};
    };
  }

  (0, _react.useEffect)(function () {
    flush.current();
    return history.listen(savedCallback.current);
  }, [history]);
};

var useNewRelicRouteTracking = function useNewRelicRouteTracking(history, getRouteSpec) {
  var pathname = history.pathname;
  var initialRouteSpec = useInitial(function () {
    return getRouteSpec(pathname);
  });

  var updateNewRelicRouteData = function updateNewRelicRouteData(routeSpec) {
    var route = routeSpec ? routeSpec.route : 'unknown-route';

    if (window.newrelic) {
      window.newrelic.setCurrentRouteName(route);
      window.newrelic.setCustomAttribute('route', route);
    }
  };

  (0, _react.useEffect)(function () {
    if (window.newrelic) {
      window.newrelic.setCustomAttribute('reactRhumbVersion', formatVersion(_legacyHubspotBenderContext.bender.depVersions['react-rhumb']));
      window.newrelic.setCustomAttribute('reaganVersion', 'react-rhumb');
    }
  }, []);
  (0, _react.useEffect)(function () {
    updateNewRelicRouteData(initialRouteSpec);
  }, [initialRouteSpec]);

  var handleHistoryChange = function handleHistoryChange(_ref3) {
    var nextPathname = _ref3.pathname;
    updateNewRelicRouteData(getRouteSpec(nextPathname));
  };

  useHistoryEffect(history, handleHistoryChange);
};

var RhumbProvider = function RhumbProvider(props) {
  usePreventPropChange(props);
  var history = props.history,
      historyPathname = props.history.pathname,
      config = props.config,
      defaultTimeout = props.defaultTimeout,
      children = props.children;
  var routeSpecs = (0, _react.useMemo)(function () {
    return buildRouteSpecs(config, defaultTimeout || Constants.DEFAULT_TIMEOUT);
  }, [config, defaultTimeout]);
  var initialState = (0, _react.useMemo)(function () {
    return {
      entry: {
        id: 0,
        pathname: historyPathname,
        referrer: undefined,
        timestamp: 0,
        checks: {},
        expiredTimestamp: null,
        dirty: false
      },
      entries: []
    };
  }, [historyPathname]);

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var getRouteSpec = (0, _react.useMemo)(function () {
    return buildGetRouteSpec(routeSpecs);
  }, [routeSpecs]);
  useNewRelicRouteTracking(history, getRouteSpec);

  var handleHistoryChange = function handleHistoryChange(_ref4) {
    var timestamp = _ref4.timestamp,
        nextPathname = _ref4.pathname;
    (0, _Scheduler.runWithLowPriority)(function () {
      dispatch({
        type: ActionTypes.HISTORY_CHANGED,
        payload: {
          pathname: nextPathname,
          timestamp: timestamp
        }
      });
    });
  };

  useHistoryEffect(history, handleHistoryChange);
  var reaganReporter = useInitial(function () {
    return (0, _reaganCompatReporter.reaganCompatReporter)(window.newrelic);
  });
  var report = (0, _react.useMemo)(function () {
    var debug = _enviro.default.debug('react-rhumb') === 'true';
    return buildReporter(getRouteSpec, function (action) {
      if (debug) {
        (0, _consoleReporter.default)(action);
      }

      reaganReporter(action);
    });
  }, [getRouteSpec, reaganReporter]);
  var checkStatus = (0, _react.useMemo)(function () {
    return buildCheckStatus(getRouteSpec);
  }, [getRouteSpec]);
  var timeoutRef = (0, _react.useRef)(null);
  var prevState = (0, _usePrevious.default)(state);
  (0, _react.useEffect)(function () {
    var handleTimeout = function handleTimeout() {
      var timestamp = (0, _performanceNow.default)();
      (0, _Scheduler.runWithLowPriority)(function () {
        dispatch({
          type: ActionTypes.TIMEDOUT,
          payload: {
            timestamp: timestamp
          }
        });
      });
    };

    var reportForStatus = function reportForStatus(status, entry) {
      switch (status.type) {
        case ResultStatus.SUCCESS:
          {
            var scenario = status.scenario;
            report(ReporterActionTypes.ROUTE_SUCCEEDED, entry, {
              scenario: scenario
            });
            break;
          }

        case ResultStatus.TIMEOUT:
          report(ReporterActionTypes.ROUTE_TIMEOUT_EXPIRED, entry);
          break;

        case ResultStatus.FAILURE:
          report(ReporterActionTypes.ROUTE_FAILED, entry);
          break;

        default:
          throw new Error("unexpected status type " + status.type);
      }
    }; // there are new history entries


    if (prevState && state.entries !== prevState.entries) {
      var prevEntry = prevState.entry,
          prevChecks = prevState.entry.checks,
          prevEntries = prevState.entries;
      var currentEntries = state.entries; // clear the timeout

      clearTimeout(timeoutRef.current);
      timeoutRef.current = null; //run through special cases

      var _currentEntries$slice = currentEntries.slice(prevEntries.length - currentEntries.length),
          _currentEntries$slice2 = (0, _toArray2.default)(_currentEntries$slice),
          trailingEntry = _currentEntries$slice2[0],
          skippedEntries = _currentEntries$slice2.slice(1);

      var trailingPathname = trailingEntry.pathname,
          trailingChecks = trailingEntry.checks;
      var trailingRouteSpec = getRouteSpec(trailingPathname);

      if (trailingRouteSpec) {
        if (trailingChecks !== prevChecks) {
          report(ReporterActionTypes.CHECKS_CHANGED, trailingEntry);
        }

        var status = checkStatus(trailingEntry);

        if (trailingEntry !== prevEntry) {
          // the previous entry changed during the last batch of updates and should be checked
          if (status.type !== ResultStatus.PENDING) {
            reportForStatus(status, trailingEntry);
          } else {
            report(ReporterActionTypes.ROUTE_ABANDONED, trailingEntry);
          }
        } else {
          if (status.type === ResultStatus.PENDING) {
            report(ReporterActionTypes.ROUTE_ABANDONED, trailingEntry);
          }
        }
      } // entries that were added between updates
      // nothing should ever have been mounted in these entries


      skippedEntries.forEach(function (skippedEntry) {
        var skippedPathname = skippedEntry.pathname;
        var skippedRouteSpec = getRouteSpec(skippedPathname);

        if (skippedRouteSpec) {
          report(ReporterActionTypes.ROUTE_STARTED, skippedEntry);
          report(ReporterActionTypes.ROUTE_ABANDONED, skippedEntry);
        } else {
          report(ReporterActionTypes.ROUTE_UNEXPECTED, skippedEntry);
        }
      });
    } // check the new entry


    if (!prevState || prevState.entries !== state.entries) {
      var currentEntry = state.entry,
          _state$entry = state.entry,
          currentPathname = _state$entry.pathname,
          currentDirty = _state$entry.dirty;
      var routeSpec = getRouteSpec(currentPathname);

      if (routeSpec) {
        report(ReporterActionTypes.ROUTE_STARTED, currentEntry);

        if (currentDirty) {
          // TODO can this ever be hit?
          report(ReporterActionTypes.CHECKS_CHANGED, currentEntry);
        }

        var _status = checkStatus(currentEntry);

        if (_status.type !== ResultStatus.PENDING) {
          // TODO can this ever be hit?
          reportForStatus(_status, currentEntry);
        } else {
          var timeout = routeSpec.timeout;
          timeoutRef.current = setTimeout(handleTimeout, timeout);
        }
      } else {
        report(ReporterActionTypes.ROUTE_UNEXPECTED, currentEntry);
      }
    } // there are no new history entries but existing entry has some changes and needs to be checked


    if (prevState && prevState.entries === state.entries && prevState.entry !== state.entry) {
      var _prevChecks = prevState.entry.checks;
      var _currentEntry = state.entry,
          _state$entry2 = state.entry,
          _currentChecks = _state$entry2.checks,
          _currentPathname = _state$entry2.pathname;

      var _routeSpec = getRouteSpec(_currentPathname);

      if (_routeSpec) {
        if (_currentChecks !== _prevChecks) {
          report(ReporterActionTypes.CHECKS_CHANGED, _currentEntry);
        }

        var _status2 = checkStatus(_currentEntry);

        if (_status2.type !== ResultStatus.PENDING) {
          reportForStatus(_status2, _currentEntry);
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
      }
    }
  }, [prevState, state, getRouteSpec, checkStatus, report]);
  (0, _react.useEffect)(function () {
    return function () {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    };
  }, []);
  var _state$entry3 = state.entry,
      currentChecks = _state$entry3.checks,
      currentId = _state$entry3.id;
  var visibleMarkers = (0, _react.useMemo)(function () {
    return Object.keys(currentChecks).filter(function (marker) {
      return currentChecks[marker].mounted;
    });
  }, [currentChecks]);
  var contextValue = (0, _react.useMemo)(function () {
    return {
      id: currentId,
      dispatch: dispatch
    };
  }, [currentId]);
  var visibleMarkersData = (0, _react.useMemo)(function () {
    return visibleMarkers.map(encodeURIComponent).join(',');
  }, [visibleMarkers]);
  return _react.default.createElement(_RhumbContext.default.Provider, {
    value: contextValue
  }, children || null, _react.default.createElement("div", {
    hidden: true,
    "aria-hidden": "true",
    "data-id-markers": visibleMarkersData
  }, visibleMarkers.map(function (marker) {
    return _react.default.createElement("mark", {
      key: marker,
      "data-id-marker": marker
    });
  })));
};

if (process.env.NODE_ENV !== 'production') {
  RhumbProvider.propTypes = {
    config: _propTypes.default.shape({}).isRequired,
    history: _propTypes.default.shape({
      listen: _propTypes.default.func.isRequired,
      pathname: _propTypes.default.string.isRequired
    }).isRequired,
    children: _propTypes.default.node,
    defaultTimeout: _propTypes.default.number
  };
}

var _default = _react.default.memo(RhumbProvider);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.5051/js/RhumbProvider.js
// module id = 548
// module chunks = 5 6